import { faBars, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Affix, Button, Layout } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useEffect, useRef, useState } from "react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { Outlet, useNavigate } from "react-router-dom";
import { RootState } from "../../app/store";
import Loading from "../../components/shared-components/Loading";
import {
  logout,
  PlayerMode,
  selectPlayer,
  setDisplayName,
} from "../../features/player/playerSlice";
import {
  openSidebar,
  selectTheme,
  setIsMobile,
  setIsTablet,
  setShowBackgroudImage,
  showFooter,
  showHeader,
  showLoginPopup,
  ThemeColor,
  ThemeMode,
} from "../../features/theme/themeSlice";
import FooterComponent from "../WelcomeLayout/components/FooterComponent";
import HeaderLinks from "../WelcomeLayout/components/HeaderLinks";
import LoginForm from "../WelcomeLayout/components/LoginForm";
import LoginFormPopup from "../WelcomeLayout/components/LoginFormPopup";
import Logo from "../WelcomeLayout/components/Logo";
import { enableSidebar, enableSidebarButton } from "../../config/constants";
import TabsBar from "../WelcomeLayout/components/TabsBar";
import HelpModal from "./components/HelpModal";
import LoggedControls from "./components/LoggedControls";
import SearchModal from "./components/SearchModal";
import SiderContent from "./components/SiderContent";
import { API, Auth } from "aws-amplify";
import { GetKioskDataQuery, Kiosk } from "../../API";
import { GRAPHQL_AUTH_MODE, GraphQLResult } from "@aws-amplify/api-graphql";
import { getKioskData } from "../../graphql/queries";
import HeaderIcons from "./components/HeaderIcons";
import PgClock from "../../components/shared-components/PgClock";

type BarsState = {
  tabsbar: boolean;
  footer: boolean;
};

const { Content, Footer, Sider, Header } = Layout;
const WelcomeLayout2 = () => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const [kioskData, setKioskData] = useState<Kiosk | null>(null);
  const theme = useAppSelector(selectTheme);
  const player = useAppSelector(selectPlayer);
  const [showTabsBar, setShowTabsBar] = useState<boolean>(true);

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  const kiosksFooter =
    player.mode === PlayerMode.KIOSK || theme.mode === ThemeMode.KIOSK
      ? true
      : false;

  const [popupLoginVisible, setLoginPopupVisible] =
    useState<boolean>(kiosksFooter);
  const onChevronClick = () => {
    setShowTabsBar(true);
    saveBarsInLocalStorage({ tabsbar: true, footer: theme.footerStatus });
  };
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const saveBarsInLocalStorage = (bars: BarsState) =>
    localStorage.setItem(
      "barsandfooter",
      JSON.stringify({
        tabsbar: bars.tabsbar,

        footer: bars.footer,
      })
    );

  useEffect(() => {
    const barsandfooter = JSON.parse(localStorage.getItem("barsandfooter"));

    if (barsandfooter && player.mode == PlayerMode.DEFAULT) {
      setShowTabsBar(barsandfooter.tabsbar);
      dispatch(openSidebar(true));
    }
  }, []);

  useEffect(() => {
    if (player.mode === PlayerMode.KIOSK) {
      (async () => {
        const result: GraphQLResult<GetKioskDataQuery> = (await API.graphql({
          query: getKioskData,
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
          variables: {},
        })) as GraphQLResult<GetKioskDataQuery>;
        dispatch(setDisplayName(result.data.getKioskData.name));
        setKioskData(result.data.getKioskData);
      })();
    }
  }, [player.username]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    window.addEventListener("keydown", (k) => {
      if (k.key == "a" && k.ctrlKey && k.altKey) {
        Auth.signOut();
        navigate("/");
        if (theme.mode === ThemeMode.KIOSK) {
          //navigate({ pathname: '/', search: '?mode=kiosk' });
          dispatch(showLoginPopup(true));
        }
        dispatch(logout());
      }
    });

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
      window.removeEventListener("keydown", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (width <= 1366 && width >= 900) {
   //   dispatch(setIsTablet(true));
      dispatch(showFooter(true));
    } else {
      dispatch(setIsTablet(false));
    }

    if (width <= 900) {
      dispatch(setIsMobile(true));
      dispatch(openSidebar(false));
      setShowTabsBar(true);
    } else {
      dispatch(setIsMobile(false));
    }
  }, [width]);

  useEffect(() => {
    dispatch(showHeader(showTabsBar));
  }, [showTabsBar]);

  useEffect(() => {
    dispatch(setShowBackgroudImage(true));
  }, [kioskData]);

  useEffect(() => {
    if (theme.mode == ThemeMode.KIOSK) setShowTabsBar(false);
  }, [theme.mode]);

  const c1 = theme.mode === ThemeMode.KIOSK ? "kiosk" : "";
  const c2 = showTabsBar ? "all-panels" : "";
  const c3 = theme.mode == ThemeMode.KIOSK || !showTabsBar ? "fullwidth" : "";

  return (

    <>
    <Affix  style={{zIndex:"99999"}}>
    <Layout 
      className={`${c1} ${c2} ${c3} ${
        theme.theme === ThemeColor.dark ? "d-dark" : "d-light"
      } ${player.logged ? "p-logged" : "p-not-logged"}`}
     
    >
      <LoginFormPopup
        visible={theme.showLoginPopup}
        onClose={() => {
          dispatch(showLoginPopup(false));
        }}
        onLoginSuccess={() => {
          dispatch(showLoginPopup(false));
        }}
      />

      <Header className="header">
        {enableSidebarButton.indexOf(location.pathname) > -1 && (
          <Button
            style={{ width: "30px" }}
            type="primary"
            className="btn-sidebar-open visible-mobile"
            onClick={() => {
              //setShowSideBar(!showSideBar);
              dispatch(openSidebar(!theme.sidebarStatus));
            }}
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
         )}
        <div className="d-logo hcol">
          {/** <PgClock /> */}
          <Logo />
        </div>
        {!theme.isMobile && <HeaderIcons />}
        <div className="d-flex f-right f-row header-right-icons">
          {!theme.isMobile && (
            <>
              <div
                className={`d-flex f-right ${
                  player.mode === PlayerMode.KIOSK
                    ? "f-row f-inverse"
                    : "f-column"
                } header-login-and-icon ${
                  showTabsBar ? "with-tab-bar" : "no-tab-bar"
                }`}
              >
                {(showTabsBar || player.mode === PlayerMode.KIOSK) && (
                  <HeaderLinks />
                )}
                {!player.logged &&
                  player.mode === PlayerMode.DEFAULT &&
                  theme.isTablet &&
                  showTabsBar && <LoginForm onLoginSuccess={() => {}} />}
                {!player.logged &&
                  player.mode === PlayerMode.DEFAULT &&
                  !theme.isTablet && <LoginForm onLoginSuccess={() => {}} />}
                {!player.logged &&
                  player.mode === PlayerMode.DEFAULT &&
                  theme.isTablet &&
                  !showTabsBar && (
                    <Button
                      type="default"
                      className="header-login-button"
                      onClick={() => {
                        dispatch(showLoginPopup(true));
                      }}
                    >
                      login
                    </Button>
                  )}
                {player.logged && <LoggedControls player={player} />}
              </div>

              {player.mode === PlayerMode.DEFAULT && (
                <div className="d-showAll">
                  <div
                    className="pointer"
                    onClick={() => {
                      onChevronClick();
                    }}
                  >
                    <FontAwesomeIcon icon={faChevronDown} />
                  </div>
                </div>
              )}
            </>
          )}
          {theme.isMobile && !player.logged && (
            <Button
              type="default"
              className="header-login-button"
              onClick={() => {
                dispatch(showLoginPopup(true));
              }}
            >
              login
            </Button>
          )}
          {theme.isMobile && player.logged && (
            <LoggedControls player={player} />
          )}
        </div>
      </Header>
      
          <TabsBar
            visible={showTabsBar && !(player.mode === PlayerMode.KIOSK)}
            openSidebarFn={() => {
              saveBarsInLocalStorage({
                tabsbar: showTabsBar,
                footer: theme.footerStatus,
              });
              //setShowSideBar(true);
              dispatch(openSidebar(true));
            }}
            onClose={() => {
              saveBarsInLocalStorage({
                tabsbar: false,
                footer: theme.footerStatus,
              });
              setShowTabsBar(false);
            }}
            sidebarOpenButton={!theme.sidebarStatus}
          />
     
      </Layout>
      </Affix>
      <Layout
          id="content-wrapper"
          className={`content-wrapper content-container
           ${
            player.mode == PlayerMode.KIOSK && kioskData
              ? 'bg bg-sf4'
              //`bg bg-${kioskData.backgroundImg.split(".")[0]}`
              : ""
          }`}
        >
          {enableSidebar.indexOf(location.pathname) > -1 && (
           <Sider
              className={`sider-mobile ${
                theme.showBackgroundImage &&
                player.mode === PlayerMode.KIOSK &&
                kioskData
                  ? "bg"
                  : ""
              }`}
              width={theme.sidebarStatus ? 287 : 0}
              
            >
              <SiderContent
                onClose={() => {
                  saveBarsInLocalStorage({
                    tabsbar: showTabsBar,
                    footer: theme.footerStatus,
                  });
                  dispatch(openSidebar(false));
                }}
              />
              </Sider>  
          )}

          <Content 
          className=  {`${theme.theme === ThemeColor.dark ? 'content d-dark' : 'content d-light'}`}
					
          >
            <Outlet />
          </Content>
        </Layout>
      <Layout>
      {player.mode !== PlayerMode.KIOSK && (
       <Affix>
      <Footer
          className={`${
            theme.footerStatus
              ? "footer"
              : theme.isTablet
              ? "footer"
              : "footer footer-minified"
          }`}
        >
          <FooterComponent
            visible={theme.footerStatus || theme.isTablet}
            onClose={() => {
              saveBarsInLocalStorage({ tabsbar: showTabsBar, footer: false });
              dispatch(showFooter(false));
            }}
            onOpen={() => {
              if (player.mode === PlayerMode.KIOSK) {
                saveBarsInLocalStorage({
                  tabsbar: showTabsBar,
                  footer: true,
                });
                dispatch(showFooter(true));
              }
            }}
          />
          {theme.isMobile && (
            <div className="footer-links-mobile">
              <HeaderLinks
                menuInverse
                noshowTicket={true}
                onUpChevron={() => {
                  dispatch(showFooter(true));
                }}
              />
            </div>
          )}
        </Footer>
        </Affix>
      )}
      </Layout>
      <SearchModal />
      <HelpModal />
      {theme.showLoading && <Loading />}
    </>
  
  );
};

export default WelcomeLayout2;
